module.exports = __webpack_public_path__ + "static/media/Skyfarm Drive, Santa Rosa, CA7.b098f231.jpg";